declare module '#app' {
  // @ts-expect-error For some reason that might throw an error, though it's valid according to the docs
  interface NuxtApp {
    $easyApi: typeof $fetch
  }
}

export default defineNuxtPlugin(() => {
  const { app } = useRuntimeConfig()
  const easyApi = $fetch.create({
    baseURL: `${app.baseURL}/api/easyApi`,
  })
  return {
    provide: {
      easyApi,
    },
  }
})
